<div class="icon-picker">
  <div class="icon-picker-toolbar">
    <input
      type="text"
      class="icon-picker-search"
      [placeholder]="text().searchPlaceholder"
      [value]="searchTerm()"
      (input)="searchTerm.set($any($event.target).value)"
    />
    <button
      type="button"
      class="icon-picker-clear"
      [class.icon-picker-clear--active]="value() === null"
      (click)="clear()"
    >
      <i class="fas fa-ban" aria-hidden="true"></i>
      <span>{{ text().noIcon }}</span>
    </button>
  </div>

  @if (results(); as searchResults) {
    @if (searchResults.total === -1) {
      <div class="icon-picker-empty">{{ text().loading }}</div>
    } @else if (searchResults.total === 0) {
      <div class="icon-picker-empty">{{ text().noResults }}</div>
    } @else {
      <div class="icon-picker-grid">
        @for (icon of searchResults.icons; track icon) {
          <button
            type="button"
            class="icon-picker-option"
            [class.icon-picker-option--selected]="value() === icon"
            [title]="icon"
            (click)="select(icon)"
          >
            <i [class]="'fas fa-' + icon" aria-hidden="true"></i>
          </button>
        }
      </div>
      @if (searchResults.total > searchResults.icons.length) {
        <div class="icon-picker-more">{{ searchResults.icons.length }} / {{ searchResults.total }}</div>
      }
    }
  } @else {
    <div class="icon-picker-grid">
      @for (icon of suggestions; track icon) {
        <button
          type="button"
          class="icon-picker-option"
          [class.icon-picker-option--selected]="value() === icon"
          [title]="icon"
          (click)="select(icon)"
        >
          <i [class]="'fas fa-' + icon" aria-hidden="true"></i>
        </button>
      }
    </div>
  }
</div>
